export const FilterPeopleTableOptions = {
  ALL: 'all',
  HAS_CONTACTED: 'hasContacted',
  NEW_REGISTERS: 'newRegisters',
}
